import { userConstants } from "../actionTypes";
import { userService } from "../middlewares/userService";
import { alertActions } from "./alertActions";
import { helper } from "../../utils/helpers/helper";

export const userActions = {
  login,
  logout,
  // refreshToken,
  forgot,
  reset_password,
  updateProfile,
  updatePassword,
  callCountryAPI,
  guidedTour,
  initGuidedTour,
};

function guidedTour(value) {
  return (dispatch) => {
    dispatch(set_state(value));
  };
  function set_state(state) {
    return { type: userConstants.STATE_GUIDED_TOUR, state };
  }
}

function initGuidedTour(value) {
  return (dispatch) => {
    dispatch(set_state(value));
  };
  function set_state(state) {
    return { type: userConstants.INITIALIZE_GUIDED_TOUR, state };
  }
}

function login(username) {
  const requestData = JSON.stringify({
    email: username.email,
    password: username.password,
  });
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request({ username }));
    userService
      .login(requestData)
      .then((response) => {
        if (!helper.isEmpty(response)) {
          const responseData = response?.data.data;
          dispatch(success(responseData));
          userService.setLocalStorage(responseData);
          localStorage.setItem("refresh_token", responseData?.refresh);
          localStorage.setItem("disconnection_time", responseData?.expires_in);
          localStorage.setItem(
            "subscription_details",
            JSON.stringify(responseData?.subscription_details)
          );
          localStorage.setItem("user", JSON.stringify(responseData?.user));
          localStorage.setItem("user_type", responseData?.user?.user_type);
          localStorage.setItem(
            "token_type",
            JSON.stringify(responseData?.token_type)
          );
          const history = username.history;
          history.push("/");
        }
      })
      .catch((error) => {
        if (error?.response) {
          const resp = error?.response?.data;
          // const errorStatus = error?.response?.status;
          if (resp?.data && error?.response?.status !== 400) {
            error = resp?.data?.message;
          } else if (error?.response?.status === 400) {
            const errorResponse = resp?.data?.errors;
            error = errorResponse.map((value, index) => {
              return value + "\n";
            });
          } else {
            error = "Network Error. Please contact your network administrator";
          }
        } else {
          error = "Please check your internet connection.";
        }
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      });
  };

  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function logout(data) {
  const token = localStorage.getItem("refresh_token");
  const requestData = JSON.stringify({
    refresh: token,
  });
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request({ token }));
    userService
      .logout(requestData)
      .then((user) => {
        if (user.status === 200) {
          // Check API response 201 condition first
          // remove user from local storage to log user out
          userService.clearLocalStorage();
          const history = data.history;
          history.push("/login");
          dispatch(success(user));
        }
      })
      .catch((error) => {
        userService.clearLocalStorage();
        const history = data.history;
        history.push("/login");
        dispatch(failure(error.toString()));
      });
  };
  function request(user) {
    return { type: userConstants.LOGOUT_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGOUT_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGOUT_FAILURE, error };
  }
}

function forgot(username) {
  const requestData = JSON.stringify({
    email: username.email,
  });
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request({ username }));
    userService
      .forgetPassword(requestData)
      .then((user) => {
        if (user?.status === 200 || user?.status === 204) {
          dispatch(alertActions.success(user?.data?.data?.message));
          // dispatch(alertActions.success('Email has been sent to your email address'));
          dispatch(success(user));
        }
      })
      .catch((error) => {
        const resp = error?.response?.data;
        // const errorStatus = error?.response?.status;
        if (resp?.data) {
          error = resp?.data?.message;
        } else {
          error = "Network Error. Please contact your network administrator";
        }
        dispatch(alertActions.error(error.toString()));
        dispatch(failure(error.toString()));
      });
  };

  function request(user) {
    return { type: userConstants.FORGET_PWD_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.FORGET_PWD_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.FORGET_PWD_FAILURE, error };
  }
}

function reset_password(username) {
  const requestData = JSON.stringify({
    new_password: username.password,
    uid: username.uid,
    token: username.token,
  });
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request());
    userService
      .reset_password(requestData)
      .then((user) => {
        if (user?.status === 200 || user?.status === 204) {
          dispatch(alertActions.success(user?.data?.data?.message));
          // dispatch(alertActions.success('Email has been sent to your email address'));
          dispatch(success(user));
        }
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (error?.response?.status === 400) {
          const errorResponse = resp?.data?.errors;
          error = errorResponse.map((value, index) => {
            return value + "\n";
          });
        } else if (
          resp?.data &&
          (error?.response?.status !== 400 || error?.response?.status !== 500)
        ) {
          error = resp?.data?.message;
        } else {
          error = "Network Error. Please contact your network administrator";
        }
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      });
  };

  function request(user) {
    return { type: userConstants.RESET_PWD_REQUEST };
  }
  function success(user) {
    return { type: userConstants.RESET_PWD_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.RESET_PWD_FAILURE, error };
  }
}

/*
function refreshToken() {
    const token = localStorage.getItem('refresh_token');
    //This code is used to refresh the web token when required
    const requestData = JSON.stringify({
        refresh: token
    });
    return dispatch => {
        dispatch(request({ token }));
        userService.refreshToken(requestData)
            .then(
                token => { 
                    userService.setLocalStorage(token);
                    dispatch(success(token));
                },
                error => {
                }
            )
            .catch(error => {
                // dispatch(failure(error.toString()));
                // dispatch(alertActions.error(error.toString()));
                userService.logout();
                return { type: userConstants.LOGOUT };
            });
    };

    function request(token) { return { type: userConstants.TOKEN_REQUEST, token } }
    function success(token) { return { type: userConstants.TOKEN_REFRESH, token } }
}
*/
function updateProfile(data) {
  const requestData = JSON.stringify({
    email: data.email,
    first_name: data.first_name,
    last_name: data.last_name,
    country: data.country?.value,
    city: data.city,
  });
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request());
    userService
      .updateProfile(requestData)
      .then((user) => {
        if (user !== undefined) {
          const resp = user?.data;
          const responseData = resp?.data;
          dispatch(success(responseData));
          dispatch(alertActions.success("Profile updated successfully"));
        }
      })
      .catch((error) => {
        // const errorMsg = error.toString();
        const resp = error?.response?.data;
        if (error?.response?.status === 400) {
          const errorResponse = resp?.data?.errors;
          error = errorResponse.map((value, index) => {
            return value + "\n";
          });
        } else if (
          resp?.data &&
          (error?.response?.status !== 400 || error?.response?.status !== 500)
        ) {
          error = resp?.data?.message;
        } else {
          error = "Network Error. Please contact your network administrator";
        }
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      });
  };

  function request() {
    return { type: userConstants.UPDATE_PROFILE_REQUEST };
  }
  function success(user) {
    return { type: userConstants.UPDATE_PROFILE_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.UPDATE_PROFILE_FAILURE, error };
  }
}
function callCountryAPI(data) {
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request());
    userService
      .getCountries()
      .then((resp) => {
        const data = resp.data.data;
        let responseObject = {
          countries: [],
          cities: [],
        };
        let countries = responseObject.countries;
        let cities = responseObject.cities;
        let countryDropdown;
        let citiesDropdown;
        data &&
          data.map((dataRecord, idx) => {
            countryDropdown = {
              id: dataRecord.id,
              value: helper.custom_str_to_lower(dataRecord.name),
              label: helper.ucfirst(dataRecord.name),
            };
            let city = dataRecord.cities;
            let cityObj = {
              id: dataRecord.id,
              values: [],
            };
            let cityValues = cityObj.values;
            city &&
              city.map((cityRecord, idx) => {
                citiesDropdown = {
                  id: cityRecord.id,
                  value: helper.custom_str_to_lower(cityRecord.name),
                  label: helper.ucfirst(cityRecord.name),
                };
                cityValues.push(citiesDropdown);
                return null;
              });
            cities.push(cityObj);
            countries.push(countryDropdown);
            return null;
          });
        let response = {
          data,
          responseObject,
        };
        dispatch(success(response));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (resp?.data) {
          error = resp?.data?.message;
        } else {
          error = "Network error. Please contact your network administrator";
        }
        dispatch(failure(error));
      });
  };

  function request() {
    return { type: userConstants.COUNTRY_REQUEST };
  }
  function success(response) {
    return { type: userConstants.COUNTRY_SUCCESS, response };
  }
  function failure(error) {
    return { type: userConstants.COUNTRY_FAILURE, error };
  }
}
function updatePassword(data) {
  const requestData = JSON.stringify({
    re_password: data.c_pwd,
    new_password: data.new_pwd,
    current_password: data.old_pwd,
  });
  return (dispatch) => {
    dispatch(alertActions.clear());
    dispatch(request({ data }));
    userService
      .changePassword(requestData)
      .then((response) => {
        const resp = response?.status;
        dispatch(alertActions.success("Password changed successfully"));
        dispatch(success(resp));
      })
      .catch((error) => {
        const resp = error?.response?.data;
        if (error?.response?.status === 400) {
          const errorResponse = resp?.data?.errors;
          error = errorResponse.map((value, index) => {
            return value + "\n";
          });
        } else if (
          resp?.data &&
          (error?.response?.status !== 400 || error?.response?.status !== 500)
        ) {
          error = resp?.data?.message;
        } else {
          error = "Network Error. Please contact your network administrator";
        }
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      });
  };

  function request(user) {
    return { type: userConstants.CHANGE_PWD_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.CHANGE_PWD_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.CHANGE_PWD_FAILURE, error };
  }
}
